import { LicenseInfo } from "@mui/x-data-grid-premium";
import LazyLoader from "components/LazyLoader";
import NavbarContainer from "components/Navbar/navbarContainer";
import ProtectedRoute from "components/ProtectedRoute";
import Topbar from "components/Topbar";
import MembersJoined from "containers/CoachApproach/MembersJoined";
import TCAReports from "containers/CoachApproach/TCAReports";
import CoachApproachAppointments from "containers/CoachApproach/TCAReports/CoachApproachAppointments";
import GroupDetails from "containers/GroupDetail";
import Groups from "containers/Groups";
import MemberDetails from "containers/MemberDetails";
import MemberTasks from "containers/MemberTasks";
import PageNotFound from "containers/PageNotFound";
import StaffDetails from "containers/StaffAccountDetails";
import StaffAccounts from "containers/StaffAccounts";
import WorkoutTemplates from "containers/WorkoutTemplates";
import CircuitView from "containers/WorkoutTemplates/CircuitView";
import ProtocolView from "containers/WorkoutTemplates/ProtocolView";
import WorkoutPlanView from "containers/WorkoutTemplates/WorkoutPlanView";
import { appActions } from "modules/app";
import { getPageTitle } from "modules/app/appServices";
import { getFacilitySettingsAction } from "modules/facility-options/facilityOptionsActions";
import { newMessageAction } from "modules/message/messageActions";
import React, { memo, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
const AdministratorTasks = React.lazy(() => import("../AdministratorTasks"));
const Members = React.lazy(() => import("../Members"));
const MembersWorkingOut = React.lazy(() => import("../MembersWorkingOut"));
const MessageCenter = React.lazy(() => import("../MessageCenter"));
const Reports = React.lazy(() => import("../Reports"));
const Interests = React.lazy(() => import("../Interests"));
const FacilityOptions = React.lazy(() => import("../FacilityOptions"));

const IndexPageComponent = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const authUser = useAppSelector((state) => state.auth.authUser);
  const messageBadge = useAppSelector((state) => state.message.newMessage);
  const pageTitle = useAppSelector((state) => state.app.pageTitle);

  LicenseInfo.setLicenseKey(
    "984a4c023d3d80676400cdee164a2ec4Tz02NTE2NCxFPTE3MTQwMTcxMjExNzEsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
  );

  useEffect(() => {
    let { shouldUpdate, title } = getPageTitle(pathname);
    if (shouldUpdate) dispatch(appActions.updatePageTitle({ title }));
  }, [pathname, dispatch]);

  useEffect(() => {
    dispatch(newMessageAction());
    dispatch(getFacilitySettingsAction());
  }, [dispatch]);

  return (
    <div className="container">
      <NavbarContainer messageBadge={messageBadge} />
      <div className="page">
        <div>
          <Topbar userData={authUser} pageTitle={pageTitle} />
        </div>
        <div className="page content">
          <Routes>
            <Route
              path="/"
              element={
                <LazyLoader>
                  <MembersWorkingOut />
                </LazyLoader>
              }
            />
            <Route
              path="/tca-members"
              element={
                <LazyLoader>
                  <MembersJoined />
                </LazyLoader>
              }
            />
            <Route
              path="/tca-reports/*"
              element={
                <LazyLoader>
                  <TCAReports />
                </LazyLoader>
              }
            />
            <Route
              path="/message-center"
              element={
                <LazyLoader>
                  <MessageCenter />
                </LazyLoader>
              }
            />
            <Route
              path="/members-working-out"
              element={
                <LazyLoader>
                  <MembersWorkingOut />
                </LazyLoader>
              }
            />
            <Route
              path="/members"
              element={
                <LazyLoader>
                  <Members />
                </LazyLoader>
              }
            />
            <Route
              path="/members/:id/*"
              element={
                <LazyLoader>
                  <MemberDetails />
                </LazyLoader>
              }
            />
            <Route
              path="/reports/*"
              element={
                <LazyLoader>
                  <Reports />
                </LazyLoader>
              }
            />
            <Route
              path="/administrator-tasks"
              element={
                <LazyLoader>
                  <AdministratorTasks />
                </LazyLoader>
              }
            />
            <Route
              path="/staffs/:id"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <StaffDetails />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/staffs"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <StaffAccounts />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/member-tasks"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <MemberTasks />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/interests"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <Interests />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/workout-templates/*"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <WorkoutTemplates />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/facility-options/*"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <FacilityOptions />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/workout-templates/circuits/:id"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <CircuitView />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/workout-templates/protocols/:id"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <ProtocolView />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/workout-templates/template/:id"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <WorkoutPlanView />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/groups"
              element={
                <ProtectedRoute user={authUser}>
                  <LazyLoader>
                    <Groups />
                  </LazyLoader>
                </ProtectedRoute>
              }
            />
            <Route
              path="/groups/:id/*"
              element={
                <LazyLoader>
                  <GroupDetails />
                </LazyLoader>
              }
            /> */}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const IndexPage = memo(IndexPageComponent);
export default IndexPage;
